var map = {
	"./SD-WAN.png": 6740,
	"./SDDC.png": 8726,
	"./SDN.png": 3219,
	"./办公自动化.png": 8188,
	"./应用性能管理.png": 1437,
	"./智能运维管理.png": 1910,
	"./模块化数字机房.png": 6318,
	"./能耗管理.png": 269,
	"./虚拟化.png": 5679,
	"./视频会议.png": 8023,
	"./超融合.png": 3096
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9222;